import type { FacebookAdConfig, HResponse } from '@/api/quickstart';
import { useRouter } from 'vue-router';

export default function useMetaCoordinator() {
  const router = useRouter();

  const accessIsForced = () => {
    const query = router.currentRoute.value.query;
    return 'force' in query;
  };

  const enforcePageAccess = async (facebookAdConfig?: HResponse<FacebookAdConfig>) => {
    if (accessIsForced()) return;

    if (!facebookAdConfig?.record) return console.error('Customer is missing initial meta record');

    const teamNeedsPhotos = !facebookAdConfig.record['team_photos?'];
    const teamNeedsToLinkAccount = facebookAdConfig.record.status === 'not_started';

    if (teamNeedsPhotos) {
      router.replace('/quickstart/meta/photos');
      return;
    }

    if (teamNeedsToLinkAccount) {
      router.replace('/quickstart/meta/access');
      return;
    }

    router.replace('/');
  };

  return {
    enforcePageAccess,
  };
}
